/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, Icon, SimpleGrid } from "@chakra-ui/react";
import MiniStatistics from "components/AppCard/Ministatistics";
import IconBox from "components/Icon";
import { UserCheck } from 'lucide-react';
import { MdGroup, MdWallet } from "react-icons/md";
import colors from "theme/foundations/colors";

export default function MiniStatsSection(props:any) {
  const {data} = props;
  const {total_payment_collected, total_tax_payers, recovery_rate} = data;

  // Chakra Color Mode
  return (
    <Box>
      <SimpleGrid
        columns={{ base: 1, md: 3, lg: 3, "2xl": 6 }}
        gap='10px'>
        <MiniStatistics
          endContent={
            <IconBox
              w='56px'
              h='56px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={
                <Icon w='25px' h='25px' as={MdWallet as any} color={'red_origin'} />
              }
            />
          }
          name='Total collecté'
          value={`${total_payment_collected} FCFA`}
        />
        {<MiniStatistics
          endContent={
            <IconBox
              w='56px'
              h='56px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={
                <Icon w='25px' h='25px' as={MdGroup as any} color={'red_origin'} />
              }
            />
          }
          name='Débiteurs assignés'
          value={total_tax_payers}
        />}
        {<MiniStatistics
          endContent={
            <IconBox
              w='56px'
              h='56px'
              borderRadius='20%'
              bg={colors.gray[100]}
              icon={<Icon w='25px' h='25px' as={UserCheck} color='red_origin' />}
            />
          }
          name='Taux de recouvrement'
          value={`${recovery_rate}%`}
        />}
      </SimpleGrid>
    </Box>
  );
}
  